import { LucideIcon, ListFilter } from 'lucide-react'

interface SidebarActionsProps {
  onToggleFilters: () => void
  items: Array<{ icon: LucideIcon; label: string }>
}

export function SidebarActions({ onToggleFilters, items }: SidebarActionsProps) {
  return (
    <div className="w-16 bg-white flex flex-col space-y-4">
      <button
        className="bg-[#F5F5F5] !rounded-[8px] p-3 w-full flex justify-center hover:bg-gray-100 transition-colors"
        onClick={onToggleFilters}
      >
        <ListFilter className="w-5 h-5 text-gray-600" />
      </button>
      <div className="bg-[#FAFAFA] rounded-lg p-3 flex flex-col items-center space-y-4">
        {items.map((item) => (
          <item.icon key={item.label} className="w-5 h-5 text-[#A3A3A3]" />
        ))}
      </div>
    </div>
  )
}

